import * as ss from 'superstruct';
import { OauthProviderT } from '../../oauth/external';

export const IntegrationConfigConfig = ss.type({
  enabledOauthIntegrations: ss.array(OauthProviderT),
});

export type IntegrationConfigConfig = ss.Infer<typeof IntegrationConfigConfig>;
